<!-- eslint-disable max-len -->
<template>
  <aha-modal
    :title="title"
    @hide="$emit('hide')"
    action-position="justify-center"
  >
    <aha-tabs-primary @update:activeIndex="onChangeTab">
      <aha-tab-item
        v-for="tab in tabs"
        :key="tab.title"
        :title="$i18nPresenter.t(tab.title)"
      />
    </aha-tabs-primary>
    <KeepAlive>
      <component
        :name="'CopySlideTo' + tabContent"
        v-aha-emit-action.view
        :is="tabContent"
        :presentationId="selectedPresentationId"
        @onLoading="onLoading"
        @onLoaded="onLoaded"
        @handlePresentationItemClick="handleSelectPresentation"
      >
        <template #interactive-button-section>
          <InsertAfterSlideCopy
            v-if="!arePresentationsLoading"
            :selectedPresentationId="selectedPresentationId"
            :areSlidesLoading="areSlidesLoading"
            :slides="slides"
            :selectedSlides="selectedSlides"
            @onChangeSelectedSlideOrder="onChangeSelectedSlideOrder"
            @onChangeIncludingResponseData="onChangeIncludingResponseData"
          />
          <ButtonSlideCopy
            v-if="!arePresentationsLoading"
            v-aha-emit-action
            :selectedPresentationId="selectedPresentationId"
            :isSlideCopying="isSlideCopying"
            @handleCopyButtonClick="() => handleCopyButtonClick([selectedPresentation])"
          />
        </template>
      </component>
    </KeepAlive>
  </aha-modal>
</template>

<script>
import SlideCopy from '@/components-v2/common/slide-copy/SlideCopy.vue'
import TabRecent from '@/components-v2/common/slide-copy/tabs/TabRecent.vue'
import TabPresentations from '@/components-v2/common/slide-copy/tabs/TabPresentations.vue'
import TabSharedPresentations from '@/components-v2/common/slide-copy/tabs/TabSharedPresentations.vue'

/**
 * @deprecated Should use MultiTabs.vue
 */

export default {
  components: {
    ...SlideCopy.components,
    TabRecent,
    TabPresentations,
    TabSharedPresentations,
  },
  extends: SlideCopy,
  data: () => ({
    tabContent: TabRecent.name,
    selectedPresentation: null,
  }),
  computed: {
    ...SlideCopy.computed,
    tabs() {
      return [
        TabRecent,
        TabPresentations,
        TabSharedPresentations,
      ]
    },
  },
  methods: {
    ...SlideCopy.methods,
    getAllUserPresentationsAndFolders() {},
    onChangeTab(index) {
      this.tabContent = this.tabs[index]?.name
      this.selectedPresentationId = null
    },
    onLoading() {
      // call when loading data
      this.arePresentationsLoading = true
    },
    onLoaded() {
      // call when loaded data
      this.arePresentationsLoading = false
    },
    handleSelectPresentation(presentation) {
      this.selectedPresentation = presentation
      this.handlePresentationItemClick(presentation)
    },
  },
}
</script>

  <style lang="scss" scoped>
  .aha-tabs {
    border-bottom: 1px solid rgb(235, 235, 235); // base-30
    @apply mb-4;
    &::v-deep .aha-tab-title {
      @apply py-2;
    }
  }
  </style>
